import { render, staticRenderFns } from "./ContactsRowSlide.vue?vue&type=template&id=76b6fbbe&scoped=true"
import script from "./ContactsRowSlide.vue?vue&type=script&lang=js"
export * from "./ContactsRowSlide.vue?vue&type=script&lang=js"
import style0 from "./ContactsRowSlide.vue?vue&type=style&index=0&id=76b6fbbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b6fbbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b6fbbe')) {
      api.createRecord('76b6fbbe', component.options)
    } else {
      api.reload('76b6fbbe', component.options)
    }
    module.hot.accept("./ContactsRowSlide.vue?vue&type=template&id=76b6fbbe&scoped=true", function () {
      api.rerender('76b6fbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/ContactsRowSlide.vue"
export default component.exports